import React from 'react';
import { useSiteSettings } from '../../hooks/useSiteSettings';

// लोडर: बीचमा साइटको लोगो (फोटो स्थिर — घुम्दैन),
// वरिपरि रातो-हरियो-पहेँलो रङको घुम्ती घेरा मात्र घुम्छ
function PageLoader({ size = 96, label = 'लोड हुँदै...' }) {
  const settings = useSiteSettings();
  const logo = settings.header_logo;

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 w-full" role="status" aria-label={label}>
      <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
        {/* Rotating color ring — red → green → yellow */}
        <div
          className="absolute inset-0 rounded-full animate-spin"
          style={{ background: 'conic-gradient(from 0deg, #C81E3A, #1F7A4D, #F5B82E, #C81E3A)' }}
        />
        {/* Static inner disc + logo photo (ghumdaina) */}
        <div className="absolute inset-[6px] rounded-full bg-white border border-line flex items-center justify-center overflow-hidden">
          {logo ? (
            <img src={logo} alt="Kalo Jhola" className="max-w-[72%] max-h-[72%] object-contain" />
          ) : (
            <span className="font-display font-bold tracking-tight text-[13px] text-ink whitespace-nowrap">
              KALO<em className="not-italic text-crimson">JHOLA</em>
            </span>
          )}
        </div>
      </div>
      <span className="text-[12.5px] font-semibold text-muted">{label}</span>
    </div>
  );
}

export default PageLoader;
